import React from "react";
import TextField from "@material-ui/core/TextField";
import "./LogInForm.css";

export default function LogInForm() {
  return (
    <>
      <TextField
        autoFocus
        margin="dense"
        id="name"
        label="Username"
        type="text"
        fullWidth
      />

      <TextField
        margin="dense"
        id="name"
        label="Password"
        type="text"
        fullWidth
      />

      <img
        src="https://img.icons8.com/color/48/000000/google-logo.png"
        alt="google"
      />
      <img
        src="https://img.icons8.com/color/48/000000/facebook.png"
        alt="facebook"
      />
    </>
  );
}
